const locale = {
    placeholder: "Sélectionner l'heure",
};
export default locale;
